import { Flame } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Displays the learner's current daily learning streak. Renders nothing when
 * the streak is zero so it stays out of the way for brand-new learners.
 */
export function StreakBadge({
  streak,
  className,
}: {
  streak: number;
  className?: string;
}) {
  if (streak <= 0) return null;

  return (
    <div
      className={cn(
        "flex items-center gap-1.5 rounded-full bg-orange-500/10 px-3 py-1.5 text-sm font-bold text-orange-600 dark:text-orange-400",
        className,
      )}
      aria-label={`${streak} day learning streak`}
      title={`${streak} day streak — keep it going!`}
    >
      <Flame className="h-4 w-4 fill-current" />
      <span className="tabular-nums">{streak}</span>
      <span className="hidden sm:inline text-xs font-semibold opacity-70">
        day{streak === 1 ? "" : "s"}
      </span>
    </div>
  );
}
